import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { motion } from 'framer-motion';

const Terms = () => {
  return (
    <div className="min-h-screen bg-background py-12 px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="max-w-3xl mx-auto"
      >
        <Link
          to="/"
          className="inline-flex items-center text-sm text-muted-foreground hover:text-foreground mb-8"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Home
        </Link>

        <div className="bg-card rounded-xl border border-border/50 shadow-lg p-8 md:p-12">
          <h1 className="text-3xl font-bold tracking-tight mb-8" data-testid="terms-title">
            Terms of Service – Nysa
          </h1>

          <div className="prose prose-gray max-w-none space-y-6">
            <p className="text-muted-foreground leading-relaxed">
              Nysa provides tools for venues and organisations to create sensory accessibility guides and visitor information.
            </p>

            <p className="text-muted-foreground leading-relaxed">
              By using the Nysa platform you agree to the following terms.
            </p>

            <section className="space-y-3">
              <h2 className="text-xl font-semibold text-foreground">Platform Use</h2>
              <p className="text-muted-foreground leading-relaxed">
                Users may create venues and sensory assessments to help improve accessibility awareness and visitor information.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-semibold text-foreground">Accuracy of Information</h2>
              <p className="text-muted-foreground leading-relaxed">
                Users are responsible for ensuring the information they submit about venues and environments is accurate to the best of their knowledge.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-semibold text-foreground">No Accessibility Certification</h2>
              <p className="text-muted-foreground leading-relaxed">
                Reports generated by Nysa are informational accessibility guides and do not constitute legal accessibility certification or compliance verification.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-semibold text-foreground">Payments</h2>
              <p className="text-muted-foreground leading-relaxed">
                Payments made through the Nysa platform are securely processed through Stripe. Nysa does not store payment card details.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-semibold text-foreground">Platform Availability</h2>
              <p className="text-muted-foreground leading-relaxed">
                We aim to provide a reliable and secure service but cannot guarantee uninterrupted access at all times.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-semibold text-foreground">Updates</h2>
              <p className="text-muted-foreground leading-relaxed">
                Nysa may update the platform and these terms periodically as the service develops.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-semibold text-foreground">Contact</h2>
              <p className="text-muted-foreground leading-relaxed">
                <a href="mailto:support@nysa.org.uk" className="text-primary hover:underline">
                  support@nysa.org.uk
                </a>
              </p>
            </section>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default Terms;
